<script context="module">
  import { is_default_product, is_default_category, is_default_playlist, is_default_project, is_default_search, is_machinable_only, handle_filters } from './FilterUtils.svelte';
  import { fixed_product, fixed_machinable_state } from './ConfigUtils.svelte';
  import { isNullOrUndefined } from './Utils.svelte';

  function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  }

  export function getURLProduct() {
      const fromParam =  getURLParameter("product");
      const fixedProduct = fixed_product(fromParam)
      return fixedProduct;
  }

  //
  // update_url(params)
  // where params = {
  //  product,
  //  category, ...
  //}
  function update_url(product, category, playlist, project, video, search, machinable_only, update_state) {
    console.log("Update url " + JSON.stringify({product, category, project, video, search}))
    let force_update = false;
    const new_product = fixed_product(product);
    if (product !== new_product) {
      if (!isNullOrUndefined(product)) {
        product = null;
        force_update = true;
      }
    }
    const new_machinable_only = fixed_machinable_state(machinable_only);
    if (machinable_only !== new_machinable_only) {
      if (!isNullOrUndefined(machinable_only)) {
        machinable_only = null;
        force_update = true;
      }
    }

    const params = [];
    if (!isNullOrUndefined(product)) {
      if (is_default_product(product)) {
        force_update = true;
      } else {
        params.push(`product=${product}`);
      }
    }
    if (!isNullOrUndefined(category)) {
      if (is_default_category(category)) {
        force_update = true;
      } else {
        params.push(`category=${category}`);
      }
    }
    if (!isNullOrUndefined(playlist)) {
      if (is_default_playlist(playlist)) {
        force_update = true;
      } else {
        params.push(`playlist=${playlist}`);
      }
    }

      if (!isNullOrUndefined(project)) {
          if (is_default_project(project)) {
              force_update = true;
          } else {
              params.push(`project=${project}`);
          }
      }

      if (!isNullOrUndefined(search)) {
          if (is_default_search(search)) {
              force_update = true;
          } else {
              params.push(`search=${search}`);
          }
      }

    if (update_state || force_update) {
      if (!isNullOrUndefined(video) && video.length > 0) {
        params.push(`video=${video}`);
      }
      if (is_machinable_only(machinable_only)) {
        params.push('machinable_only=true');
      }
      console.log("update history state")
      console.log({params})
      history.pushState(null, null, `?${params.join('&')}`);
    }

    handle_filters(new_product, category, playlist, project, video, search, new_machinable_only);
  }

  export function update_playlist(playlist) {
    const product = getURLParameter("product");
    const machinable_only = getURLParameter("machinable_only");
    update_url(product, null, playlist, null, null, null, machinable_only, true);
  }

  export function update_video(video) {
    const product = getURLParameter("product");
    const playlist = getURLParameter("playlist");
    const category = getURLParameter("category");
    const project = getURLParameter("project");
    const search = getURLParameter("search");
    const machinable_only = getURLParameter("machinable_only");
    update_url(product,  category, playlist, project, video, search, machinable_only, true);
  }

  export function update_video_search(video,category) {
      const product = getURLParameter("product");
      const playlist = getURLParameter("playlist");
      const project = getURLParameter("project");
      const search = getURLParameter("search");
      const machinable_only = getURLParameter("machinable_only");
      console.log('video '+video + 'cat: '+category);
     // update_url(product,  category, playlist, project, video, search, machinable_only, true);
  }

  export function update_video_category(video, category) {
      const product = getURLParameter("product");
      const machinable_only = getURLParameter("machinable_only");
      update_url(product,  category, null, null, video, null, machinable_only, true);
  }

  export function update_search(search) {
    const product = getURLParameter("product");
    const video = getURLParameter("video");
    const machinable_only = getURLParameter("machinable_only");
    if(search == '') {
        update_url(product, null, null, null, video, null, machinable_only, true);
    } else {
        update_url(product, null, null, null, video, search, machinable_only, true);
    }
  }
  
  export function redo_search(search) {
    const product = getURLParameter("product");
    const video = getURLParameter("video");
    const machinable_only = getURLParameter("machinable_only");
    update_url(product, null, null, null, video, null, machinable_only, true);
  }

  export function update_category(category) {
      const product = getURLParameter("product");
      const playlist = getURLParameter("category");
      const project = getURLParameter("project");
      const video = getURLParameter("video");
      const search = getURLParameter("search");
      const machinable_only = getURLParameter("machinable_only");
      update_url(product, category, null, null, video, search, machinable_only, true);
  }

  export function update_project(project) {
      const product = getURLParameter("product");
      const video = getURLParameter("video");
      const search = getURLParameter("search");
      const machinable_only = getURLParameter("machinable_only");
      update_url(product, null, null, project, video, search, machinable_only, true);
  }

  export function update_from_url() {
    const product = getURLParameter("product");
    const playlist = getURLParameter("playlist");
    const category = getURLParameter("category");
    const video = getURLParameter("video");
    const project = getURLParameter("project");
    const search = getURLParameter("search");
    const machinable_only = getURLParameter("machinable_only");
    update_url(product, category, playlist, project, video, search, machinable_only, false);
  }

  export function update_video_and_state(category, playlist, project, video) {
    const product = getURLParameter("product");
    const machinable_only = getURLParameter("machinable_only");
    update_url(product, category, playlist, project, video, null, machinable_only, true);
  }

  window.addEventListener('popstate', function (event) {
    update_from_url();
  });

  export function reset_url() {
      const product = getURLParameter("product");
      const machinable_only = getURLParameter("machinable_only");
      update_url(product, null, null, null, null, null, machinable_only, true);
  }

  export function clean_the_url() {
      const product = getURLParameter("product");
      const playlist = getURLParameter("playlist");
      const category = getURLParameter("category");
      const video = getURLParameter("video");
      const project = getURLParameter("project");
      const search = getURLParameter("search");
      const machinable_only = getURLParameter("machinable_only");
      update_url(product, category, playlist, project, video, search, machinable_only, true);
  }

</script>
